<template>
    <div>
        <a @click.prevent="addNewItem = true" href="#" class="-ml-px relative flex items-center px-4 py-2 border text-sm font-medium rounded-md text-blue-50 bg-blue-500 hover:bg-dark-color focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500">
            <svg class="w-6 h-6 mr-1 text-blue-100" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
            <span>Submit Wire Request</span>
        </a>

        <div v-if="addNewItem" class="bg-blue-50 border-blue-400 rounded-lg my-4 pt-8 pb-5 px-5 relative">
            <div class="fixed z-10 inset-0 overflow-y-auto">
                <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                    <div class="fixed inset-0 transition-opacity" aria-hidden="true" @click="addNewItem = false">
                        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                    </div>

                    <!-- This element is to trick the browser into centering the modal contents. -->
                    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
                    <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all ease-out duration-300 sm:my-8 sm:align-middle sm:max-w-3xl sm:w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                        <div class="flex justify-between items-center mb-4 bg-blue-50 border-b border-blue-100 p-4">
                            <p class="text-xl font-semibold text-blue-900">Add New</p>
                            <svg @click="addNewItem = false" class="w-6 h-6 text-gray-400 cursor-pointer hover:text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
                        </div>
                        <div class="px-4 pt-2 pb-4 sm:p-6 sm:pt-2">
                            <div class="rounded-md bg-yellow-50 p-4 mb-4">
                                <div class="flex">
                                    <div class="flex-shrink-0">
                                        <svg class="h-5 w-5 text-primary-color" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                            <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
                                        </svg>
                                    </div>
                                    <div class="ml-3">
                                        <h3 class="text-sm font-medium text-yellow-800">
                                            Attention
                                        </h3>
                                        <div class="mt-2 text-sm text-yellow-700">
                                            <p>
                                                Wire & ACH Request Deadlines are 11:30 AM (Monday-Friday).

                                            </p>
                                            <p class="text-sm mt-2"><i>Using the ACH method, your bank account will be credited on the following business day.</i></p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <form @submit.prevent="submit"  class="grid grid-cols-6 gap-6">
                                <div class="col-span-6 sm:col-span-3">
                                    <fieldset>
                                        <div>
                                            <legend class="text-base font-medium text-gray-900">Wire Method</legend>
                                            <p class="text-sm text-gray-500">Please select a method for the wire.</p>
                                        </div>
                                        <div class="mt-4 space-y-4">
                                            <div class="flex items-center">
                                                <input id="ach" name="method" v-model="newItem.method" value="ach" type="radio" class="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300">
                                                <label for="ach" class="ml-3 block text-sm font-medium text-gray-700">
                                                    ACH
                                                </label>
                                            </div>
                                            <div class="flex items-center">
                                                <input id="wire" checked="checked" name="method" v-model="newItem.method"  value="wire" type="radio" class="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300">
                                                <label for="wire" class="ml-3 block text-sm font-medium text-gray-700">
                                                    Wire
                                                </label>
                                            </div>
                                        </div>
                                    </fieldset>
                                </div>
                                <div class="col-span-6 sm:col-span-3 grid grid-cols-6">
                                    <div class="col-span-6">
                                        <label for="bank_account" class="block text-sm font-medium text-gray-700">Bank Account</label>
                                        <select-input required v-model="newItem.account" name="bank_account" id="bank_account" class="mt-1">
                                            <option v-for="account in accounts" :value="account">{{ account }}</option>
                                        </select-input>
                                    </div>
                                    <div class="col-span-6 mt-8">
                                        <label for="wire_amount" class="block text-sm font-medium text-gray-700">Wire Amount</label>
                                        <text-input required v-model="newItem.amount" type="number" step=".01" min=".01" name="wire_amount" id="wire_amount" class="mt-1" />
                                    </div>
                                </div>

                                <div class="col-span-6">
                                    <div class="flex justify-end items-center mt-2">

                                        <loading-button :loading="saving"  type="submit" class="">
                                            Save
                                        </loading-button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LoadingButton from "@/Shared/LoadingButton";
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'

export default {
    components: { TextInput, SelectInput, LoadingButton },
    props: {
        accounts: {
            type: Array,
            default: []
        },
    },
    data() {
        return {
            saving: false,
            addNewItem: false,
            newItem: {
                method: 'wire',
            }
        }
    },
    methods: {
        submit() {
            this.$inertia.post(this.route('wires.store'), this.newItem, {
                onStart: () => this.saving = true,
                onFinish: () => this.saving = false,
                onSuccess: () => {
                    this.addNewItem = false,
                    this.newItem = {
                        method: 'wire',
                    }
                },
            })
        }
    }
}
</script>
